import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询财务操作日志
export const queryFinanceLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFinanceLogs', { ...state.logs, loading: true });
    const res: IPageData = await $http.post('/v1/finance/service/log', payload);
    commit('setFinanceLogs', { data: res.list, total: res.total, pageNum: res.pageNum, pageSize: res.pageSize });
  } catch (e) {
    commit('setFinanceLogs', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};
